import React from "react";

import createNamespace from "services/language";
import Route from "components/common/History/Route";
import { ORGANIZATION_OVERVIEW } from "utils/constants/routes";

const AdminOverview = React.lazy(() => import("./index"));

export default createNamespace({
  namespace: "adminOverview",
  Component: function Main() {
    return (
      <>
        <Route
          adminOnly
          path={ORGANIZATION_OVERVIEW.ROOT}
          component={AdminOverview}
        />
      </>
    );
  },
});
